import React from 'react';
import Nav from '../Nav';

const OrderPage =() => {

    return (
        <>
           <Nav></Nav>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <h1>Order a deliver</h1>
        </>
    )
}

export default OrderPage